import { z } from 'zod';

export const Id = z.string().min(1);
/** Competência como inteiro AAAAMM (ex.: 202603). Anual usa AAAA12; trimestral usa o mês final. */
export const CompetenciaChave = z.number().int().min(190001).max(299912);
/** A mesma competência vinda de querystring (chega como texto). */
export const CompetenciaChaveQuery = z.coerce.number().int().min(190001).max(299912);
/** Data ISO sem hora (AAAA-MM-DD). */
export const DataISO = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'data no formato AAAA-MM-DD');

/** Booleano vindo de querystring: "true"/"1" → true; "false"/"0"/ausente → false (z.coerce.boolean() trataria "false" como true). */
export const BoolQuery = z.preprocess((v) => v === true || v === 'true' || v === '1', z.boolean());

export const Paginacao = z.object({
  page: z.coerce.number().int().min(1).default(1),
  perPage: z.coerce.number().int().min(1).max(200).default(50),
});
export type Paginacao = z.infer<typeof Paginacao>;

export const Erro = z.object({
  erro: z.string(),
  codigo: z.string().optional(),
  detalhes: z.unknown().optional(),
});
export type Erro = z.infer<typeof Erro>;

export const Ok = z.object({ ok: z.literal(true) });

/** Somente dígitos de um CNPJ/CPF. */
export function soDigitos(v: string): string {
  return v.replace(/\D+/g, '');
}

/**
 * Limpa um CNPJ/CPF mantendo letras: o CNPJ alfanumérico (IN RFB 2.229/2024, vigente desde 07/2026) tem 12 posições
 * alfanuméricas + 2 dígitos verificadores. Letras viram maiúsculas; pontuação sai.
 */
export function limparDocumento(v: string): string {
  return v.toUpperCase().replace(/[^0-9A-Z]+/g, '');
}

/** Máscara enquanto digita: 11 dígitos → CPF; 12 alfanuméricos + 2 dígitos → CNPJ (00.000.000/0000-00). */
export function mascaraDocumento(v: string): string {
  const d = limparDocumento(v).slice(0, 14);
  const soNum = /^\d*$/.test(d);
  if (soNum && d.length <= 11) return d.replace(/^(\d{3})(\d{0,3})(\d{0,3})(\d{0,2}).*/, (_m, a, b, c, e) => [a, b, c].filter(Boolean).join('.') + (e ? `-${e}` : ''));
  return d.replace(/^(.{2})(.{0,3})(.{0,3})(.{0,4})(\d{0,2}).*/, (_m, a, b, c, e, f) => `${a}${b ? `.${b}` : ''}${c ? `.${c}` : ''}${e ? `/${e}` : ''}${f ? `-${f}` : ''}`);
}
